import { posthog } from 'posthog-js';
import { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import { userStore } from '~/lib/stores/user';

export const usePosthogUserProperties = () => {
  const userData = useStore(userStore);

  useEffect(() => {
    if (userData) {
      // Set user properties
      posthog.people.set({
        email: userData.email,
        is_subscribed: userData.isSubscribed,
        prompts_used: userData.promptsUsed,
        max_prompts: userData.maxPrompts,
        plan_name: userData.planName,
        $initial_referrer: document.referrer,
        $initial_referring_domain: document.referrer ? new URL(document.referrer).hostname : null,
      });

      // Set computed properties
      posthog.people.set({
        prompts_remaining: Number(userData.maxPrompts) - Number(userData.promptsUsed),
        usage_percentage: (Number(userData.promptsUsed) / Number(userData.maxPrompts)) * 100,
      });
    }
  }, [userData]);

  const updateUserProperty = (key: string, value: any) => {
    posthog.people.set({ [key]: value });
  };

  const incrementUserProperty = (key: string, value: number = 1) => {
    const currentValue = Number(posthog.get_property(key) || 0);
    posthog.people.set({ [key]: currentValue + value });
  };

  const appendToUserProperty = (key: string, value: any) => {
    const currentValue = posthog.get_property(key) || [];

    if (Array.isArray(currentValue)) {
      posthog.people.set({ [key]: [...currentValue, value] });
    } else {
      posthog.people.set({ [key]: [value] });
    }
  };

  return {
    updateUserProperty,
    incrementUserProperty,
    appendToUserProperty,
  };
};

export default usePosthogUserProperties;
